// extracted by mini-css-extract-plugin
module.exports =  {"headerIcon":"---src-components-DeviceDetails-HistoryDownload__headerIcon--kxdjT"};